module.exports = __webpack_public_path__ + "img/public_login@2x.a14404fb.png";